import { ProductImage } from './adsGenerator.types';

// Same limits as the console's productImageUpload.js.
export const MAX_PRODUCT_IMAGES = 5;
export const MAX_PRODUCT_IMAGE_BYTES = 5 * 1024 * 1024;
export const ACCEPTED_PRODUCT_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
];

export const productImageRejection = (file: File): string => {
  if (!ACCEPTED_PRODUCT_IMAGE_TYPES.includes(file.type)) {
    return 'Only JPG, PNG or WebP images can be used';
  }
  if (file.size > MAX_PRODUCT_IMAGE_BYTES) {
    return 'Each image must be under 5 MB';
  }
  return '';
};

export const toProductImage = (file: File): ProductImage => ({
  id: `${file.name}-${file.size}-${Math.random().toString(36).slice(2)}`,
  name: file.name,
  file,
  previewUrl: window.URL.createObjectURL(file),
});

export const releaseProductImage = (image: ProductImage): void => {
  window.URL.revokeObjectURL(image.previewUrl);
};
